/*
 * Copyright (c) 2022 SARL SIGMA POLYNESIA
 */

import { FormattedMessage, useIntl } from 'react-intl'
import { Table } from '@mantine/core'
import SelectionToggle from '../../../../client/js/components/selection/SelectionToggle'
import ManagementReportListItem from './ManagementReportListItem'

export type ManagementReportListProps = {
  items: ManagementReport[],
  selectable?: boolean
}

function ManagementReportList (props: ManagementReportListProps) {
  const { items, selectable, ...others } = props
  const intl = useIntl()
  return (
    <Table highlightOnHover {...others}>
      <Table.Thead>
        <Table.Tr>
          {selectable
            ? <Table.Th w={50}>
              <SelectionToggle />
            </Table.Th>
            : null}
          <Table.Th w={200}>
            <FormattedMessage
              id="photo"
              defaultMessage="Photo"
            />
          </Table.Th>
          <Table.Th w={150}>
            {intl.formatMessage({
              id: 'report',
              defaultMessage: 'Rapport'
            })}
          </Table.Th>
          <Table.Th>
            {intl.formatMessage({
              id: 'owner',
              defaultMessage: 'Propriétaire'
            })}
          </Table.Th>
          <Table.Th>
            {intl.formatMessage({
              id: 'estate',
              defaultMessage: 'Bien'
            })}
          </Table.Th>
          <Table.Th w={120} ta="end">
            {intl.formatMessage({
              id: 'balance',
              defaultMessage: 'Solde'
            })}
          </Table.Th>
        </Table.Tr>
      </Table.Thead>
      <Table.Tbody>
        {items.map((report) => (
          <ManagementReportListItem
            key={report.id}
            item={report}
            selectable={selectable}
          />
        ))}
      </Table.Tbody>
    </Table>
  )
}

export default ManagementReportList
